export function getEnvironmentFromApiKey(apiKey: string) {
  return apiKey.startsWith('pk_live') || apiKey.startsWith('sk_live')
    ? 'production'
    : 'sandbox';
}
